module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', {
    staticClass: "mt-4"
  }, [_vm._v("Requirement Types")]), _vm._v(" "), (_vm.requirementTypes.length > 0) ? _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('strong', [_vm._v("Name")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('strong', [_vm._v("Prefix")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "1"
    }
  }, [_c('strong', [_vm._v("Level")])])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.requirementTypes), function(requirementType) {
    return _c('div', [(_vm.currentlyEditingARequirementType && _vm.requirementTypeIdBeingEdited === requirementType.requirement_type_id) ? _c('b-row', {
      staticClass: "mb-1 mt-1"
    }, [_c('b-col', {
      attrs: {
        "cols": "3"
      }
    }, [_c('b-form-input', {
      attrs: {
        "type": "text",
        "id": "requirement-type-name",
        "placeholder": "Requirement type name"
      },
      model: {
        value: (_vm.updateRequirementTypeName),
        callback: function($$v) {
          _vm.updateRequirementTypeName = $$v
        },
        expression: "updateRequirementTypeName"
      }
    })], 1), _vm._v(" "), _c('b-col', {
      attrs: {
        "cols": "3"
      }
    }, [_c('b-form-input', {
      attrs: {
        "type": "text",
        "id": "requirement-type-prefix",
        "placeholder": "Requirement type prefix"
      },
      model: {
        value: (_vm.updateRequirementTypePrefix),
        callback: function($$v) {
          _vm.updateRequirementTypePrefix = $$v
        },
        expression: "updateRequirementTypePrefix"
      }
    })], 1), _vm._v(" "), _c('b-col', {
      attrs: {
        "cols": "1"
      }
    }, [_c('b-form-input', {
      attrs: {
        "type": "number",
        "id": "requirement-type-level",
        "placeholder": "Requirement type level"
      },
      model: {
        value: (_vm.updateRequirementTypeLevel),
        callback: function($$v) {
          _vm.updateRequirementTypeLevel = $$v
        },
        expression: "updateRequirementTypeLevel"
      }
    })], 1), _vm._v(" "), _c('b-col', {
      attrs: {
        "cols": "3"
      }
    }, [_c('b-button-group', [_c('b-button', {
      attrs: {
        "variant": "primary",
        "size": "sm",
        "disabled": !_vm.updateRequirementTypeName || !_vm.updateRequirementTypePrefix
      },
      on: {
        "click": function($event) {
          _vm.updateRequirementType(requirementType.requirement_type_id)
        }
      }
    }, [_vm._v("Submit")]), _vm._v(" "), _c('b-button', {
      attrs: {
        "size": "sm"
      },
      on: {
        "click": _vm.disableUpdateRequirementTypeForm
      }
    }, [_vm._v("Cancel")])], 1)], 1)], 1) : _c('b-row', {
      staticClass: "mb-1 mt-1"
    }, [_c('b-col', {
      attrs: {
        "cols": "3"
      }
    }, [_vm._v("\n        " + _vm._s(requirementType.name) + "\n      ")]), _vm._v(" "), _c('b-col', {
      attrs: {
        "cols": "3"
      }
    }, [_vm._v("\n        " + _vm._s(requirementType.prefix) + "\n      ")]), _vm._v(" "), _c('b-col', {
      attrs: {
        "cols": "1"
      }
    }, [_vm._v("\n        " + _vm._s(requirementType.level) + "\n      ")]), _vm._v(" "), _c('b-col', {
      attrs: {
        "cols": "3"
      }
    }, [_c('b-button', {
      attrs: {
        "variant": "warning",
        "size": "sm",
        "disabled": _vm.currentlyEditingARequirementType || _vm.showNewRequirementTypeForm
      },
      on: {
        "click": function($event) {
          _vm.enableUpdateRequirementTypeForm(requirementType)
        }
      }
    }, [_vm._v("Edit")]), _vm._v(" "), _c('b-button', {
      attrs: {
        "variant": "danger",
        "size": "sm",
        "disabled": _vm.currentlyEditingARequirementType || _vm.showNewRequirementTypeForm
      },
      on: {
        "click": function($event) {
          _vm.deleteRequirementType(requirementType.requirement_type_id)
        }
      }
    }, [_vm._v("Delete")])], 1)], 1)], 1)
  }), _vm._v(" "), _c('b-row', {
    staticClass: "mt-2 mb-2"
  }, [_c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [(!_vm.showNewRequirementTypeForm) ? _c('b-button', {
    attrs: {
      "variant": "primary",
      "disabled": _vm.currentlyEditingARequirementType
    },
    on: {
      "click": _vm.enableNewRequirementTypeForm
    }
  }, [_vm._v("New requirement type")]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.showNewRequirementTypeForm) ? _c('div', {
    staticClass: "form-group mt-2 mb-2"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "id": "requirement-type-name",
      "placeholder": "Requirement type name"
    },
    model: {
      value: (_vm.newRequirementTypeName),
      callback: function($$v) {
        _vm.newRequirementTypeName = $$v
      },
      expression: "newRequirementTypeName"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "id": "requirement-type-prefix",
      "placeholder": "Requirement type prefix"
    },
    model: {
      value: (_vm.newRequirementTypePrefix),
      callback: function($$v) {
        _vm.newRequirementTypePrefix = $$v
      },
      expression: "newRequirementTypePrefix"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('b-button-group', [_c('b-button', {
    attrs: {
      "variant": "primary",
      "disabled": !_vm.newRequirementTypeName || !_vm.newRequirementTypePrefix
    },
    on: {
      "click": _vm.createRequirementType
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('b-button', {
    on: {
      "click": _vm.disableNewRequirementTypeForm
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)], 1) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b160030"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/configuration/RequirementTypesView.vue
// module id = 1010
// module chunks = 1